import { CustomJobPhase } from "hooks/jobs/job-phases/useGetJobPhase";
import { range } from "ramda";

export default function generateBlocksForJobPhase({
  jobPhase,
  organizationSettings,
  showTravelTo,
  showTravelFrom,
}: {
  jobPhase: CustomJobPhase;
  organizationSettings: Record<string, string>;
  showTravelTo: boolean;
  showTravelFrom: boolean;
}) {
  const averageWorkingHours = +organizationSettings?.average_working_hours_per_day || 8;
  const createBlock = (blockLength: number) => ({
    scheduledAt: "",
    blockLength,
    showTravelTo,
    showTravelFrom,
  });

  if (!jobPhase.jobDuration || jobPhase.jobDuration <= 0) {
    return [createBlock(averageWorkingHours)];
  }

  const daysRequired = jobPhase.jobDuration / averageWorkingHours;
  const blocksRequired = Math.ceil(daysRequired);

  const blocks = range(1, blocksRequired + 1).map((blockIndex) => {
    const blockLength =
      blockIndex > daysRequired
        ? +((daysRequired % Math.floor(daysRequired)) * averageWorkingHours).toFixed(2) ||
          jobPhase.jobDuration
        : averageWorkingHours;

    return createBlock(blockLength);
  });

  return blocks;
}
